import { render, staticRenderFns } from "./payerList.vue?vue&type=template&id=7395c3c4&scoped=true&"
import script from "./payerList.vue?vue&type=script&lang=js&"
export * from "./payerList.vue?vue&type=script&lang=js&"
import style0 from "./payerList.vue?vue&type=style&index=0&id=7395c3c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7395c3c4",
  null
  
)

export default component.exports